import { Component, Inject, OnInit, forwardRef } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { AppComponent } from 'src/app/app.component';
import { LoginService } from 'src/app/login.service';
import { TranslatorService } from 'src/app/translator.service';
import { getAuth, isSignInWithEmailLink, onAuthStateChanged, signInWithEmailLink } from 'firebase/auth';

@Component({
  selector: 'app-auth-popup',
  templateUrl: './auth-popup.component.html',
  styleUrls: ['./auth-popup.component.scss'],
})
export class AuthPopupComponent implements OnInit {
  public email = '';
  public linkval='';
  public submitted = false;
  // eslint-disable-next-line max-len
  public message = 'Va rugam sa introduceti adresa de email asociata contului Dvs. In cazul in care nu aveti un cont activ, vom genera unul automat pentru Dvs. dupa completarea datelor. Va rugam sa introduceti adresa de email, sa apasati butonul Autentificare email si sa verificati atat in Inbox cat si in Spam mail-ul pentru autentificare.';
  constructor(public translatorService: TranslatorService, public loginService: LoginService,
    public modalCtrl: ModalController, public navCtrl: NavController) { }

  ngOnInit() { }

  sendEmail() {
    if (this.email.length !== 0) {
      this.loginService.sendEmailLink(this.email);
      this.submitted = true;
      this.message = 'Va multumim! Va rugam sa verificati atat in Inbox cat si in Spam mail-ul pentru autentificare. Dacă întâmpinați probleme în a vă autentifica vă rugăm să copiați link-ul primit pe email și să il introduceți în căsuța de mai jos.';
    }
    else {
      alert('Va rugam sa introduceti o adresa de email valida!');
    }
  }

  sendLink() {
    if (this.linkval.length !== 0) {
      //this.app_component.loginPath();
      this.loginPath();
    }
    else {
      alert('Va rugam sa introduceti link-ul primit în email!');
    }
  }
  justVisiting() {
    this.navCtrl.navigateForward('tab3');
    this.modalCtrl.dismiss();
  }
  public loginPath()
  {
    const auth = getAuth();
      if (isSignInWithEmailLink(auth, this.linkval)) {
        const email = window.localStorage.getItem('emailForSignIn');
        signInWithEmailLink(auth, email, this.linkval)
          .then((result) => {
            window.localStorage.removeItem('emailForSignIn');
          })
          .catch((error) => {
            //this.navCtrl.navigateForward('tabs/tab4');
          });
      }
      else
      {
        alert("Link-ul introdus nu este corect!")
      }
  }
}
